import useSWR from 'swr';
import { accountService } from '@/services/api';
import { config } from '@/config';
import { useRouter } from '@/hooks/general/useRouter/useRouter';
import { AwaitedReturnType } from '@/types/helpers';
import { FetchErrorsType } from '@/types/types/general/errors';

const ACCOUNT_URL = config.api.url.account;

export const useAccountDetailsQuery = (isAllowedToRequestAuthorizedData = true) => {
    const router = useRouter();
    const { data } = useSWR(
        ACCOUNT_URL,
        () =>
            isAllowedToRequestAuthorizedData
                ? accountService.getAccountData({ routerPush: router.push })
                : undefined,
        {
            refreshInterval: config.timeout.accountDataRevalidate,
        },
    );
    return data;
};

export const useAccountTaxDetailsQuery = () => {
    return useSWR(`${ACCOUNT_URL}/tax-details`, () => accountService.getAccountTaxDetails(), {
        errorRetryCount: 2,
        revalidateOnFocus: false,
        refreshInterval: config.timeout.accountDataRevalidate,
    });
};

export const useGetTOTPSecretQuery = () => {
    return useSWR<AwaitedReturnType<typeof accountService.getTOTPSecret>, FetchErrorsType>(
        `${ACCOUNT_URL}/TOTP`,
        () => accountService.getTOTPSecret(),
        {
            errorRetryCount: 2,
            revalidateOnFocus: false,
        },
    );
};

export const useInvoicingDetailsQuery = () => {
    const fetcher = () => accountService.getInvoicingDetails();
    return useSWR<AwaitedReturnType<typeof fetcher>, FetchErrorsType>(
        `${ACCOUNT_URL}/user/invoicing`,
        fetcher,
    );
};
